import { gql, useApolloClient } from '@apollo/client'

const OPERATION_ENABLE_SITE = gql`
  mutation SilentModeEnableSite($id: Int!) {
    status: silentModeEnableSite(id: $id)
  }
`

const OPERATION_DISABLE_SITE = gql`
  mutation SilentModeDisableSite($id: Int!) {
    status: silentModeDisableSite(id: $id)
  }
`

const OPERATION_ENABLE_GROUP = gql`
  mutation SilentModeEnableGroup($code: String!) {
    status: silentModeEnableGroup(code: $code)
  }
`

const OPERATION_DISABLE_GROUP = gql`
  mutation SilentModeDisableGroup($code: String!) {
    status: silentModeDisableGroup(code: $code)
  }
`

export const OPERATION_SILENT_MODE_GROUPS = gql`
  query silentModeGroups {
    groups: silentModeGroups {
      code
      name
      sites {
        id
        name
        checked
      }
    }
  }
`

const useSilentMode = () => {
  const client = useApolloClient()
  const enableSite = async (id) => {
    const data = await client.mutate({
      mutation: OPERATION_ENABLE_SITE,
      variables: { id },
      update: (cache, {data}) => {
        cache.updateQuery({
          query: OPERATION_SILENT_MODE_GROUPS,
        },
        (oldData) => {
          if (!data.status) {
            return oldData
          }
          return {
            groups: oldData.groups.map(group => ({
              ...group,
              sites: group.sites.map(site => ({...site, checked: site.id === id ? true : site.checked}))
            }))
          }
        })
      }
    })
    return data.status
  }

  const disableSite = async (id) => {
    const data = await client.mutate({
      mutation: OPERATION_DISABLE_SITE,
      variables: { id },
      update: (cache, { data }) => {
        cache.updateQuery({
          query: OPERATION_SILENT_MODE_GROUPS,
        },
        (oldData) => {
          if (!data.status) {
            return oldData
          }
          return {
            groups: oldData.groups.map(group => ({
              ...group,
              sites: group.sites.map(site => ({...site, checked: site.id === id ? false : site.checked}))
            }))
          }
        })
      }
    })
    return data.status
  }

  const enableGroup = async (code) => {
    const data = await client.mutate({
      mutation: OPERATION_ENABLE_GROUP,
      variables: { code },
      update: (cache, {data}) => {
        cache.updateQuery({
            query: OPERATION_SILENT_MODE_GROUPS,
          },
          (oldData) => {
            if (!data.status) {
              return oldData
            }
            return {
              groups: oldData.groups.map(group => ({
                ...group,
                sites: group.sites.map(site => ({...site, checked: group.code === code ? true : site.checked}))
              }))
            }
          })
      }
    })
    return data.status
  }

  const disableGroup = async (code) => {
    const data = await client.mutate({
      mutation: OPERATION_DISABLE_GROUP,
      variables: { code },
      update: (cache, { data }) => {
        cache.updateQuery({
            query: OPERATION_SILENT_MODE_GROUPS,
          },
          (oldData) => {
            if (!data.status) {
              return oldData
            }
            return {
              groups: oldData.groups.map(group => ({
                ...group,
                sites: group.sites.map(site => ({...site, checked: group.code === code ? false : site.checked}))
              }))
            }
          })
      }
    })
    return data.status
  }

  return {
    enableSite,
    disableSite,
    enableGroup,
    disableGroup
  }
}

export default useSilentMode